'use client';

import React from 'react';

import { FormBlock } from '@/blocks/Form/Component';
import { Modal } from '@ui/modal';
import { useForm } from './queries';

export function ModalForm({
  toggle,
  toggleStyle,
  title,
  additionalSubmissionData,
  formId,
  type = 'callback',
}: {
  toggle: React.ReactElement;
  toggleStyle?: string;
  title?: string;
  additionalSubmissionData?: {
    field: string;
    value: string;
  }[];
  formId?: number;
  type?: 'callback';
}) {
  const { data, error, isLoading } = useForm(formId);

  return (
    <Modal
      toggle={toggle}
      toggleStyle={toggleStyle}
      innerStyle="pt-12"
      size="sm"
    >
      {({ setIsOpen }) => (
        <>
          <h5 className="h4 mb-8">{data.title || 'Запись на консультацию'}</h5>
          {data && (
            <FormBlock
              theme="secondary"
              form={data}
              callback={() => setIsOpen(false)}
              additionalSubmissionData={additionalSubmissionData}
            />
          )}
        </>
      )}
    </Modal>
  );
}
